// context/ArticlesProvider.js
import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import authHeader from "../../Auth/authHeader";
import { errorAlert } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";

export const PaymentContext = createContext();

export const PaymentProvider = ({ children }) => {
    const [paymentsOptions, setPaymentOptions] = useState([]);
    const headers = authHeader();


    const fetchPaymentsOptions = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Accounts/paymenttype', { headers });
            setPaymentOptions(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë");
            }
        }
    };

    useEffect(() => {
        fetchPaymentsOptions();
    }, []);

    return (
        <PaymentContext.Provider value={{ paymentsOptions, fetchPaymentsOptions }}>
            {children}
        </PaymentContext.Provider>
    );
};
